import React from "react"
import { isEqual } from "lodash-es"
import { useSelector } from "react-redux"
import { getFilteredReports } from "reduxSlices/reportIndexSlice"
import { TASK_REPORT_TYPE } from "utils/reportHelpers"
import TaskReportRow from "./TaskReportRow"

const TaskReportList = () => {
  const reports = useSelector(getFilteredReports(TASK_REPORT_TYPE), isEqual)

  return (
    <div className="flex flex-col items-center justify-center">
      {
        reports.map((report) => (
          <TaskReportRow report={report} key={report.id} />
        ))
      }
    </div>
  )
}

export default TaskReportList
